import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, UpsertSalesForceIntegrationBodySchema } from "schema"
import { z } from "zod"
import { salesForceIntegrationQuery } from "../../lib/salesForce/salesForceIntegrationQuery"

type Response = DataResponse<z.infer<typeof UpsertSalesForceIntegrationBodySchema>>

export function useUpsertSalesForceIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertSalesForceIntegrationBodySchema>) => {
      const response = await axios.post<Response>(`/integrations/salesForce/configuration`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: salesForceIntegrationQuery().queryKey })
    },
  })
}
